/**
 * Die linke Menüleiste: ausgeklappt mit Beschriftung, eingeklappt nur die
 * Symbole. Die Wahl merkt sich der Browser — wer die schmale Leiste mag,
 * bekommt sie beim nächsten Mal wieder.
 */

import { useState } from 'react';

const SCHLUESSEL = 'bp_leiste_schmal';

export function useLeisteSchmal(): [boolean, (wert: boolean) => void] {
  const [schmal, setSchmal] = useState<boolean>(() => {
    try {
      return localStorage.getItem(SCHLUESSEL) === '1';
    } catch {
      return false;
    }
  });
  function setzen(wert: boolean) {
    setSchmal(wert);
    try {
      localStorage.setItem(SCHLUESSEL, wert ? '1' : '0');
    } catch {
      // Nur eine Bequemlichkeit.
    }
  }
  return [schmal, setzen];
}

export function LeistenSchalter({ schmal, onWechsel }: { schmal: boolean; onWechsel: (wert: boolean) => void }) {
  return (
    <button
      className="leisten-schalter"
      onClick={() => onWechsel(!schmal)}
      aria-label={schmal ? 'Menü ausklappen' : 'Menü einklappen'}
      title={schmal ? 'Menü ausklappen' : 'Menü einklappen'}
      aria-expanded={!schmal}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {schmal ? <path d="M9 6l6 6-6 6" /> : <path d="M15 6l-6 6 6 6" />}
      </svg>
      <span>{schmal ? '' : 'Einklappen'}</span>
    </button>
  );
}

/** Symbole der Verwaltungsleiste. */
export function VerwaltungSymbol({ wert }: { wert: string }) {
  const g = { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };
  switch (wert) {
    case 'pruefungen':
      return (
        <svg {...g}>
          <path d="M9 3h6l1 2h3v16H5V5h3z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      );
    case 'einstellungen':
      return (
        <svg {...g}>
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
        </svg>
      );
    default:
      return (
        <svg {...g}>
          <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6" />
        </svg>
      );
  }
}
